import Vue from "vue";
import url from "./apiUrls";
import { store } from "../../store/store";

export const entityVideo = new Vue({
  methods: {
    getAllVideos(token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .get(url.videoEntity, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    getVideoByCourseId(courseId) {
      const accessToken = store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${accessToken} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.videoByCourseId}${courseId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    addVideo(videoData, token) {
      const accessToken = token ? token : store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${accessToken} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.addVideo, videoData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    removeVideo(videoId, token) {
      const accessToken = token ? token : store.state.adminAuth.accessToken;
      const headerData = {
        Authorization: `Bearer ${accessToken} `,
        "Content-Type": "application/json"
      };
      const getUrl = `${url.removeVideo}${videoId}`;
      return new Promise((resolve, reject) => {
        this.$http
          .get(getUrl, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    editVideo(videoData, token) {
      const headerData = {
        Authorization: `Bearer ${token} `,
        "Content-Type": "application/json"
      };
      return new Promise((resolve, reject) => {
        this.$http
          .post(url.editVideo, videoData, { headers: headerData })
          .then(res => {
            console.log(res);
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  }
});
